module.exports = __webpack_public_path__ + "frontend-assets/img/karotsi.c95c2c3c.png";